var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightellipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 526,
    viewBox: "0 0 629 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 33",
    filter: "url(#filter0_f_361_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.847 113.054C67.0116 69.4029 74.3346 11.1857 114.203 -16.9782C154.072 -45.1421 211.389 -32.5876 242.225 11.0631C256.279 30.9578 265.6 58.399 267.808 85.0417C270.444 116.855 262.939 147.53 241.242 162.857C219.91 177.927 197.465 134.514 168.779 121.949C143.852 111.031 112.184 133.348 97.847 113.054Z",
    fill: "#F3D968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_361_407",
    x: -281.229,
    y: -392.013,
    width: 909.542,
    height: 918.009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180,
    result: "effect1_foregroundBlur_361_407"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightellipse);
export default __webpack_public_path__ + "static/media/rightellipse.cf57f087947d3321bb7eb79497819556.svg";
export { ForwardRef as ReactComponent };